import React, { createContext, useEffect, useReducer } from 'react'
import axios from '../../../axios';
import MatxLoading from "../../components/MatxLoading";
import {useParams} from "react-router-dom";

const initialValue = {
    sale_detail: {}
};
const reducer = (state, action) => {
    switch (action.type) {
        case 'LOAD_SALE_DETAIL_DATA': {
            return {
                ...state,
                sale_detail_list: action.payload,
            }
        }
        case 'UPDATE_SALE_DETAIL_DATA': {
            let newData = state.sale_detail_list.sale_detail.sale_products.filter((pro) =>
                action.payload.product_id !== pro.product_id
            );
            let newState = {
                sale_detail: {...state.sale_detail_list.sale_detail, sale_products: newData}
            }

            return {
                ...state,
                sale_detail_list: newState,
            }
        }
        default: {
            return state
        }
    }
}

const SaleDetailContext = createContext({
    sale_detail_list: initialValue,
    getSaleDetail: () => {},
    removeProduct: () => {},
})

export const SaleDetailProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, {})
    let  { id } = useParams();

    const getSaleDetail = async (id) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get('/api/sales/get_sale_detail/'+id, options);

            dispatch({
                type: 'LOAD_SALE_DETAIL_DATA',
                payload: res.data,
            })
        } catch (e) {
            console.error(e)
        }
    }

    const removeProduct = async (id, sale_id) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get('/api/sales/remove_sale_product/'+id+"/"+sale_id, options);

            dispatch({
                type: 'UPDATE_SALE_DETAIL_DATA',
                payload: {sale_id: sale_id, product_id: id},
            })
        } catch (e) {
            console.error(e)
        }
    }

    useEffect(() => {
        getSaleDetail(id);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    if(state.sale_detail_list === undefined) {
        return <MatxLoading />
    }

    return (
        <SaleDetailContext.Provider
            value={{
                sale_detail_list: state.sale_detail_list,
                getSaleDetail,
                removeProduct,
            }}
        >
            {children}
        </SaleDetailContext.Provider>
    )
}

export default SaleDetailContext
